<template>
  <div class="detail-page">
    <!-- 领取中 -->
    <div v-if="loading" class="errText"></div>
    <!-- 领取失败 -->
    <div v-else-if="errMsg" class="errText">{{ errMsg }}</div>
    <!-- 领取成功 -->
    <template v-else>
      <div class="header">
        <img
          class="mascot"
          :src="require('@/assets/imgs/xibNewCustomerGift/detailLogo.png')"
        />
        <div class="title">领取成功</div>
        <div class="subtitle">请前往【微信卡包】查看你的立减金</div>
      </div>

      <div class="detail-box" v-for="(item, ind) in detailData" :key="ind">
        <!-- 微信立减金 -->
        <div class="row">
          <img
            class="thumb"
            :src="require('@/assets/imgs/xibNewCustomerGift/detailWx.png')"
          />
          <div class="col head">
            <div class="name">{{ item.stockName || '-' }}</div>
            <div class="time">有效期至：{{ item.validityDateEnd }}</div>
          </div>
        </div>
      </div>
      <!-- 温馨提示 -->
      <div class="warm-tips">
        <div class="tips-title">·温馨提示·</div>
        <div class="tips" v-html="warmTips"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { xibNewCustomerReceive } from '@/api/xibNewCustomerGift'
import useClipboard from 'vue-clipboard3'
const { toClipboard } = useClipboard()
export default {
  data() {
    return {
      warmTips: `
            1、微信立减金在持卡人单笔消费满足立减金使用门槛并通过微信支付选择使用厦门国际银行借记卡支付时使用。若该笔订单发生全额退款，且优惠券仍在有期内，优惠券将自动退还,如优惠券已过期，则不退还;如发生部分退款该订单支付金额将按比例原路退还,优惠券将不退还。<br/>

            2、微信立减金限微信支付商家使用，个人收款码、生活缴费、理财交易等不可使用。部分商户不支持使用(目前立减金不可核销的商户名单:CCo奶茶优衣库、星巴克、肯德基、必胜客、同程艺龙、热风、太平鸟、孩子王、航联保险、华为商城、Miss Sixty、Ochirly、Apple 商城、Five Plus、零钱通、理财通<br/>

            3、如立减金在使用过程中出现任何问题，请联系活动支持方易点生活电子商务有限公司进行咨询，客服热线
            400-662-7299。`, // 温馨提示
      detailData: [],
      loading: true
    }
  },
  created() {
    this.handleReceive()
  },
  methods: {
    async handleReceive() {
      try {
        // 跳转微信小程序先存储国际银行带过来的token
        const { urlToken } = this.$route.query
        if (urlToken) {
          sessionStorage.setItem('xiameBankPromotionJhToken', urlToken)
        }
        this.loading = true
        const { data } = await xibNewCustomerReceive({
          receiveType: 1, // 权益类型：领取类型，1-微信立减金，2-厦门国际银行积分
          code: sessionStorage.getItem('ydsh-ph-h5-bankv3-wxcode'),
          userRightsToken: this.$route.query.userRightsToken
        })
        // sendRes发放结果：1-发放成功，0-发放失败
        if (data.sendRes !== 1) {
          this.loading = false
          this.$router.push({
            path: '/xiameBankPromotionGiftFailDetail'
          })
          return
        }
        this.detailData = data?.goodsList|| []
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
        this.errMsg = e.message
      }
    },
    async copy(text) {
      try {
        await toClipboard(text)
        this.$toast.success('复制成功!')
      } catch (e) {
        console.error(e)
        this.$toast.fail('复制失败!')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.detail-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fdddf4 0%, #e0f1fb 100%);
  padding: 16px 12px 24px;
  box-sizing: border-box;
  .header {
    text-align: center;
    margin-bottom: 20px;
    .mascot {
      width: 77px;
      height: 91px;
      object-fit: contain;
    }
    .title {
      margin-top: 6px;
      font-size: 18px;
      font-weight: normal;
      color: #1c0960;
    }
    .subtitle {
      margin-top: 12px;
      color: #6a6a6a;
      font-size: 12px;
    }
  }
  .detail-box {
    background: #ffffff;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    margin-bottom: 8px;
    .row {
      display: flex;
      // align-items: center;
      .thumb {
        width: 111px;
        height: 74px;
        border-radius: 8px;
        object-fit: cover;
        margin-right: 10px;
      }
      .col {
        flex: 1;
        width: 0;
        .name {
          font-size: 16px;
          font-weight: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: 6px;
        }
        .time {
          color: #999999;
          font-size: 12px;
          margin-top: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .warm-tips {
    background: #fff;
    border-radius: 10px;
    padding: 20px 15px 35px;
    // margin-top: 8px;
    .tips-title {
      font-weight: 600;
      color: #000000;
      margin-bottom: 6px;
      text-align: center;
      font-size: 17px;
    }
    .tips {
      color: #666;
      font-size: 12px;
      line-height: 18px;
      padding: 0 2px 0;
    }
  }
}
</style>
